<div class="login-container">
  <mat-card class="mat-card">
    <mat-card-header>
      <mat-card-title class="title-center">
        <div class="title-container">
          <span class="title-text">Login</span>
          <mat-icon class="login-icon" matSuffix>login</mat-icon>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="spacer"></div>
        <mat-form-field class="full-width">
          <mat-label>Username</mat-label>
          <input matInput formControlName="username" placeholder="Enter your username">
          <mat-icon matSuffix>person</mat-icon>
        </mat-form-field>
        <mat-form-field class="full-width">
          <mat-label>Password</mat-label>
          <input matInput type="password" formControlName="password" placeholder="Enter your password">
          <mat-icon matSuffix>lock</mat-icon>
        </mat-form-field>
        <button mat-raised-button color="primary" type="submit" class="full-width">Login</button>
        <div *ngIf="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>
        <mat-divider></mat-divider>
      </form>
    </mat-card-content>
  </mat-card>
</div>